'use client';

import Link from '@eliadmin/core/src/components/link';

import type { Menu } from '@eliadmin/core/src/api/general/types/general-layout-types';

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@eliadmin/core/src/components/ui/accordion';

import { Heading } from '../ui/heading';
import { getSafeHref } from '@eliadmin/core/src/utils/url-utils';
import { Paragraph } from '../ui/paragraph';

export function MenuAccordion({ menu }: { menu: Menu[] }) {
  return (
    <Accordion
      type="single"
      collapsible
      className="flex w-full flex-col items-start justify-start gap-3 sm:hidden"
    >
      {menu.map(menu => (
        <AccordionItem
          value={menu.name}
          key={menu.name}
          className="w-full border-b border-t-0 border-b-white/20 p-0"
        >
          <AccordionTrigger className="w-full p-0 pb-3 no-underline">
            <span className="h5 uppercase text-white no-underline">{menu.name}</span>
          </AccordionTrigger>
          <AccordionContent className="flex w-full flex-col items-start justify-start gap-3 p-0 pb-3">
            {menu.fields.map(field => (
              <Link
                key={field.name}
                href={getSafeHref(field?.path ?? '#')}
                prefetch={false}
                className="text-white"
              >
                <Paragraph size="lg" color="white">
                  {field.name}
                </Paragraph>
              </Link>
            ))}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
